// Map form values to API format
export const mapFormDataToAPI = (values: any, fields: any[]) =>
  fields.map((field) => {
    let fieldValue = values[field.name];
    // If the value is an object with a 'value' property, use that
    if (
      fieldValue &&
      typeof fieldValue === "object" &&
      "value" in fieldValue
    ) {
      // Special handling for RelationWithStudent fields - use only value
      if (/basicCoApplicant\d+RelationWithStudent/i.test(field.name)) {
        fieldValue = fieldValue.value;
      }
      // Special handling for university field
      else if (field.name == "university") {
        fieldValue = `${fieldValue.label}-${fieldValue.value}`;
      }
      // Default behavior for other autocomplete fields
      else {
        fieldValue = fieldValue.label;
      }
    }

    return {
      field_id: field.id,
      field_key: field.name,
      field_value: fieldValue ?? "",
    };
  });

// Master-data dropdowns (e.g. designation) store the option's code in the
// form, but the API formData expects the full name (label). Accepts either the
// code or the name, and falls back to the raw value when it isn't in the
// loaded list.
export const getMasterOptionName = (
  rawValue: any,
  options: Array<{ value: any; label: any }> = [],
): string => {
  const code =
    rawValue && typeof rawValue === "object" ? rawValue.value ?? rawValue.label : rawValue;
  if (code === undefined || code === null || code === "") return "";
  const match = options.find(
    (option) => String(option.value) === String(code) || option.label === String(code),
  );
  return match?.label ?? String(code);
};

  export const updateLeadPayloadData =(trackingId: string, dataval: any) =>
  {
    return {
        trackingId: String(trackingId),
        leadType:dataval?.leadType,
        leadSource:dataval?.leadSource,
        leadSystem: dataval?.leadSystem,
        partnerLead: dataval?.partnerLead,
        qualifiedPartner: dataval?.qualifiedPartner,
        marketingLead:dataval?. marketingLead,
        leadSubSource: dataval?.leadSubSource,
        undergraduateFlag: dataval?.undergraduateFlag,
        partnerFirmId:dataval?.partnerFirmId,
    };
  }